import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

import Applications from '../pages/Dashboard/Applications';
import Identifies from '../pages/Dashboard/Identifies';
import Register from '../pages/Register';
import About from '../pages/About';
import Home from '../pages/Home';
import EditApp from '../pages/EditApp';
import EditIdentify from '../pages/Dashboard/EditIdentify';
import Identify from '../pages/Dashboard/Identity';
import Application from '../pages/Dashboard/Application';
import AdminPanel from 'pages/Dashboard/AdminPanel';
import Wizard from '../pages/Wizard';
// NOTE: distinct from `Identify` above, which is pages/Dashboard/Identity.
// This is the standalone identity + contract flow.
import IdentifyFlow from '../pages/Identify';
import Intro from '../pages/Intro';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/register" element={<Register />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* Dashboard Route */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        }
      />

      {/* Protected Routes */}
      <Route
        path="/applications"
        element={
          <ProtectedRoute>
            <Applications />
          </ProtectedRoute>
        }
      />
      <Route
        path="/identities"
        element={
          <ProtectedRoute>
            <Identifies />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/editapp"
        element={
          <ProtectedRoute>
            <EditApp />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/edit-identity"
        element={
          <ProtectedRoute>
            <EditIdentify />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/identify/:id"
        element={
          <ProtectedRoute>
            <Identify />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/application/:id"
        element={
          <ProtectedRoute>
            <Application />
          </ProtectedRoute>
        }
      />
      <Route
        path="/wizard"
        element={
          <ProtectedRoute>
            <Wizard />
          </ProtectedRoute>
        }
      />
      <Route path="/intro" element={<Intro />} />
      <Route
        path="/identify"
        element={
          <ProtectedRoute>
            <IdentifyFlow />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
